

exports.__esModule = true;

var _index = require('squid/index');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Route.extend('$xoEConsentPageRoute', {

    path: 'econsent',
    directive: _directive2['default'],
    titleContent: 'eConsent.title',

    trackingData: {
        fptiState: 'econsent',
        templateName: 'eConsent.dust',
        pageGoal: 'eConsent',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-econsent',
                'pagename2': '%::fullpage-econsent:member:hermes:',
                'version': 'member:%:'
            }
            // More page qualifiers come here...
        }
    },

    children: []
});


_index.$Route;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-eConsent/route.js
 ** module id = 420
 ** module chunks = 1
 **/